export const resolveDatatableComponent = (component, rootId) => {
  if (component && typeof component !== "string") {
    return component;
  }
  const registry = (window as any).DatatableComponentRegistry || {};
  return registry[component || rootId];
};
